import { InjectionToken } from '@angular/core';

export interface EnvironmentBase {
  production: boolean;
  apiBaseUrl: string;
  version: string;
  app: string;
  env: string;
  appInsights: {
    instrumentationKey: string;
  };

  AadClientId: string;
  AadScope: string;
  AadAuthorityDomain: string;
  AadSignupSigninUrl: string;
  AadPasswordResetUrl: string;
}

export const APP_ENV = new InjectionToken<EnvironmentBase>('APP_ENV');
